import {
    get,
    isEqual
} from 'lodash';
import {
    prettifyCardNumber,
    prettifyDate,
    prettifyDateNoTimeZone
} from './string';
import {
    cardTypesMapper,
    processMethodMapper,
    transactionStatusMapper,
    transactionTypeMapper,
    getCurrencyCode,
    gatewayTypeMapper
} from '@nexio/emvio-util-app';
import { fraudMapper } from '../App/Fraud/Fraud';
import { prettifyNumber } from '@nexio/emvio-util-app/src/string';

export const cycleTypes = ['0th: Canceled', '1st: Initial', '2nd: Won', '3rd: Represent', '4th: Final'];

export function transformUppercaseCell(props) {
    return (props.value ? props.value.toUpperCase() : '');
}

export function transformCurrencyCodeCell(props) {
    return getCurrencyCode(props.value).toUpperCase();
}

export function transformEllipsisNumberCell(props) {
    return (props.value ? prettifyCardNumber(props.value) : '');
}

export function transformDateCell(props) {
    return (props.value ? prettifyDate(props.value, { returnDateOnly: true }) : '');
}

export function transformDateTimeCell(props) {
    return (props.value ? prettifyDate(props.value) : '');
}

export function transformMonthYearCell(props) {
    return (props.value ? prettifyDate(props.value, { dateTimeFormatOutput: 'MMMM YYYY' }) : '');
}

export function transformActionCell(props) {
    if (isEqual(props.value, 'settled')) {
        return 'Refund';
    } else if (isEqual(props.value, 'voided')) {
        return '';
    } else {
        return 'Void';
    }
}

export function transformDateCellNoTimeZone(props) {
    return (props.value ? prettifyDateNoTimeZone(props.value) : '');
}

export function transformCardTypeCell(props) {
    return (props.value ? cardTypesMapper[props.value].toUpperCase() : '');
}

export function transformProcessMethodCell(props) {
    return get(processMethodMapper, props.value, '').toUpperCase();
}

export function transformTransactionTypeCell(props) {
    return get(transactionTypeMapper, props.value, '').toUpperCase();
}

export function transformTransactionStatusCell(props) {
    return get(transactionStatusMapper, props.value, '').toUpperCase();
}

export function transformGatewayTypeCell(props) {
    return get(gatewayTypeMapper, props.value, '').toUpperCase();
}

export function transformFraudStatusCell(props) {
    return fraudMapper[props.value];
}

export function transformDateLongLocalizeCell(props) {
    return (props.value ? prettifyDate(props.value, { dateTimeFormatOutput: 'YYYY-MM-DD h:mm:ss A' }) : '');
}

export function transformNumberLocalizeCell(props) {
    return prettifyNumber(props.value);
}
